<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/AdminReport/Survey'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div
                class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"
                v-show="this.$root.canShow(['super_admin', 'ADMIN_PM'])"
              >
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'reAgentCodes'"
                        :name="'reAgentCodes'"
                        :select2-options="reAgentCodesOptions"
                        v-model="reAgentCodes"
                        ref="reAgentCodesSelect2"
                        multiple
                    ></select2> -->
                  <treeselect
                    v-model="reAgentCodes"
                    :multiple="true"
                    :options="reAgentCodesOptions"
                    v-on:open="LoadreAgentCodesOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reDepartments'"
                    :name="'reDepartments'"
                    :select2-options="reDepartmentsOptions"
                    multiple
                    v-model="reDepartments"
                  ></select2> -->
                  <treeselect
                    v-model="reDepartments"
                    :multiple="true"
                    :options="reDepartmentsOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทกิจกรรม:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reType'"
                    :name="'reType'"
                    :select2-options="reTypeOptions"
                    v-model="reType"
                    ref="reTypeSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>เดือน:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reMonth'"
                    :name="'reMonth'"
                    :select2-options="reMonthOptions"
                    v-model="reMonth"
                    ref="reMonthSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ปี :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reYear'"
                    :name="'reYear'"
                    :select2-options="reYearOptions"
                    v-model="reYear"
                    ref="reYear"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะร้านค้า:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reShopStatus'"
                    :name="'reShopStatus'"
                    :select2-options="reShopStatusOptions"
                    v-model="reShopStatus"
                    ref="reShopStatusSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <select2
                    id="reProductBrandId"
                    name="reProductBrandId"
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :select2-options="reProductBrandIdOptions"
                    v-model="reProductBrandId"
                    ref="reProductBrandIdSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ผู้ดำเนินการ:</label>
                  <treeselect
                    v-model="reUserIds"
                    :multiple="true"
                    :options="reUserIdsOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะผู้ดำเนินการ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reUserStatus'"
                    :name="'reUserStatus'"
                    :select2-options="reUserStatusOptions"
                    v-model="reUserStatus"
                    ref="reUserStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset($event)"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportMasterShop"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="SurveyTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="46">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">รหัสตัวแทนจำหน่าย</th>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย</th>
                    <th class="all text-center">เขตการขาย</th>
                    <th class="all text-center">รหัสร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                    <th class="all text-center">ที่อยู่</th>
                    <th class="all text-center">ตำบล</th>
                    <th class="all text-center">อำเภอ</th>
                    <th class="all text-center">จังหวัด</th>
                    <th class="all text-center">รหัสไปรษณีย์</th>
                    <th class="all text-center">เดือน</th>
                    <th class="all text-center">ปี</th>
                    <!-- <th class="all text-center">Brand</th> -->
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">ผู้ดำเนินการ</th>
                    <th class="all text-center">D01</th>
                    <th class="all text-center">D02</th>
                    <th class="all text-center">D03</th>
                    <th class="all text-center">D04</th>
                    <th class="all text-center">D05</th>
                    <th class="all text-center">D06</th>
                    <th class="all text-center">D07</th>
                    <th class="all text-center">D08</th>
                    <th class="all text-center">D09</th>
                    <th class="all text-center">D10</th>
                    <th class="all text-center">D11</th>
                    <th class="all text-center">D12</th>
                    <th class="all text-center">D13</th>
                    <th class="all text-center">D14</th>
                    <th class="all text-center">D15</th>
                    <th class="all text-center">D16</th>
                    <th class="all text-center">D17</th>
                    <th class="all text-center">D18</th>
                    <th class="all text-center">D19</th>
                    <th class="all text-center">D20</th>
                    <th class="all text-center">D21</th>
                    <th class="all text-center">D22</th>
                    <th class="all text-center">D23</th>
                    <th class="all text-center">D24</th>
                    <th class="all text-center">D25</th>
                    <th class="all text-center">D26</th>
                    <th class="all text-center">D27</th>
                    <th class="all text-center">D28</th>
                    <th class="all text-center">D29</th>
                    <th class="all text-center">D30</th>
                    <th class="all text-center">D31</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reAaIsInitial: true,
      reAaDateReq: null,
      reDepartments: [],
      reAgentCodes: [],
      reShopTypeId: [],
      reType: null,
      reMonth: null,
      reYear: null,
      reShopStatus: 'ACTIVE',
      reProductBrandId: null,
      reUserIds: [],
      reUserIdsOptions: [],
      reUserStatus: null,
      brandHeaders: [],
      reDepartmentsOptions: [],
      // reDepartmentsOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเขตการขาย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchDepartment",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAgentCodesOptions: [],
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url:
      //       "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
      reMonthOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "1", text: "January", data: null },
          { id: "2", text: "February", data: null },
          { id: "3", text: "March", data: null },
          { id: "4", text: "April", data: null },
          { id: "5", text: "May", data: null },
          { id: "5", text: "June", data: null },
          { id: "7", text: "July", data: null },
          { id: "8", text: "August", data: null },
          { id: "9", text: "September", data: null },
          { id: "10", text: "October", data: null },
          { id: "11", text: "November", data: null },
          { id: "12", text: "December", data: null },
        ],
      },
      reYearOptions: {
        placeholder: "กรุณาเลือก",
        data: [
          {
            id: new Date().getFullYear(),
            text: new Date().getFullYear(),
            data: null,
          },
          {
            id: new Date().getFullYear() + 1,
            text: new Date().getFullYear() + 1,
            data: null,
          },
          {
            id: new Date().getFullYear() + 2,
            text: new Date().getFullYear() + 2,
            data: null,
          },
          {
            id: new Date().getFullYear() + 3,
            text: new Date().getFullYear() + 3,
            data: null,
          },
          {
            id: new Date().getFullYear() + 4,
            text: new Date().getFullYear() + 4,
            data: null,
          },
        ],
      },
      reShopStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "ACTIVE", text: "ร้านเปิด", data: null },
          { id: "INACTIVE", text: "ร้านปิด", data: null },
        ],
      },
      reUserStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
      reProductBrandIdOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกแบรนด์สินค้า",
        ajax: {
          url: "/Api/ProductBrand/Select2ProductBrand",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reTypeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "PM", text: "PM", data: null },
          { id: "QI", text: "QC", data: null },
          { id: "MKT", text: "MKT", data: null },
          { id: "MT", text: "MT", data: null },
        ],
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reDepartments = [];
      self.reAgentCodes = [];
      self.reType = null;
      (self.reMonth = null), (self.reYear = null);
      self.reShopStatus = 'ACTIVE';
      self.reProductBrandId = null;
      self.reUserIds = [];
      self.reUserStatus = null;

      $("#reDepartments")
        .val("")
        .trigger("change");

      $("#reAgentCodes")
        .val("")
        .trigger("change");

      $("#reMonth")
        .val("")
        .trigger("change");

      $("#reYear")
        .val("")
        .trigger("change");

      $("#reShopStatus")
        .val(self.reShopStatus)
        .trigger("change");

      $("#reProductBrandId")
        .val("")
        .trigger("change");

      $("#reType")
        .val("")
        .trigger("change");

      $("#reUserIds")
        .val("")
        .trigger("change");

      $("#reUserStatus")
        .val("")
        .trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function(e, innerText = null) {
      let self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();
      var table = $("#SurveyTable").DataTable();
      table.draw();
    },
    exportMasterShop: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportSurvey",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.reAgentCodes,
          Department: self.reDepartments,
          ProductBrandId: self.reProductBrandId,
          Month: self.reMonth,
          Year: self.reYear,
          Status: self.reShopStatus,
          TypeModule: self.reType,
          UserIds: self.reUserIds,
          UserStatus: self.reUserStatus,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadreDepartmentsOptions: function(e) {
      var self = this;
      // axios
      //   .get("/Api/Agents/Select2SearchDepartment", {
      //     params: {
      //       page: 1,
      //       all: true,
      //     },
      //   })
      //   .then(function(response) {
      //     if (response.status == 200) {
      //       var data = response.data.results;
      //       data.forEach((element) => {
      //         self.reDepartmentsOptions.push({
      //           id: element.id,
      //           label: element.text,
      //         });
      //       });
      //     }
      //   })
      //   .catch(function(error) {});
      axios
        .get("/Api/MasterSalesArea/FindOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reDepartmentsOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAgentCodesOptions: function(e) {
      var self = this;
      self.reAgentCodesOptions = [{ id : "", label : "Loading...", isDisabled: true}]; // เพื่อไม่ให้ใส่ว่าไม่มีข้อมูลระหว่างโหลด
      axios
        .post(
          "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
          {
            province_id: [],
            department: self.reDepartments,
            AgentCodes: [],
            page: 1,
            all: true,
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            self.reAgentCodesOptions = []; // เพื่อไม่ให้ใส่ว่าไม่มีข้อมูลระหว่างโหลด
            var data = response.data.results;
            data.forEach((element) => {
              self.reAgentCodesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadUserIdsOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Survey/UserOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reUserIdsOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;

    self.LoadreDepartmentsOptions();
    self.LoadreAgentCodesOptions();
    self.LoadUserIdsOptions();
    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#SurveyTable");
    table.DataTable({
      autoWidth: true,
      scrollY: "100%",
      scrollX: true,
      responsive: true,
      processing: true,
      serverSide: true,
      searchDelay: 500,
      ajax: {
        url: "/Api/Report/Survey",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        beforeSend: function(request) {
          request.setRequestHeader(
            "Authorization",
            "Bearer " + self.$root.user.access_token
          );
        },
        data: function(d) {
          let jsonSearch = {
            AgentCode: self.reAgentCodes,
            Department: self.reDepartments,
            ProductBrandId: self.reProductBrandId,
            Month: self.reMonth,
            Year: self.reYear,
            Status: self.reShopStatus,
            TypeModule: self.reType,
            IsInitial: self.reAaIsInitial,
            UserIds: self.reUserIds,
            UserStatus: self.reUserStatus,
          };
          return JSON.stringify($.extend(d, jsonSearch));
        },
      },
      // DOM Layout settings
      dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

      lengthMenu: [30, 50, 100],

      pageLength: 30,

      language: {
        lengthMenu: "Display _MENU_",
      },
      // Order settings
      order: [[11, "desc"]],
      columns: [
        { data: "agentCode", className: "text-center" },
        { data: "agentName", className: "text-center" },
        { data: "department", className: "text-center" },
        { data: "custCode", className: "text-center" },
        { data: "name1", className: "text-center" },
        { data: "name2", className: "text-center" },
        { data: "address", className: "text-center" },
        { data: "tambon", className: "text-center" },
        { data: "amper", className: "text-center" },
        { data: "province", className: "text-center" },
        { data: "zipCode", className: "text-center" },
        // { data: "month", className: "text-center" },
        {
          data: "monthInt",
          className: "text-center",
          render: function(data, type, full, meta) {
            return full.month;
          },
        },
        { data: "year", className: "text-center" },
        { data: "brand", className: "text-center" },
        // { data: "แบรนด์สินค้า", className: "text-center" },
        { data: "fullName", className: "text-center" },
        { data: "d01", className: "text-center" },
        { data: "d02", className: "text-center" },
        { data: "d03", className: "text-center" },
        { data: "d04", className: "text-center" },
        { data: "d05", className: "text-center" },
        { data: "d06", className: "text-center" },
        { data: "d07", className: "text-center" },
        { data: "d08", className: "text-center" },
        { data: "d09", className: "text-center" },
        { data: "d10", className: "text-center" },
        { data: "d11", className: "text-center" },
        { data: "d12", className: "text-center" },
        { data: "d13", className: "text-center" },
        { data: "d14", className: "text-center" },
        { data: "d15", className: "text-center" },
        { data: "d16", className: "text-center" },
        { data: "d17", className: "text-center" },
        { data: "d18", className: "text-center" },
        { data: "d19", className: "text-center" },
        { data: "d20", className: "text-center" },
        { data: "d21", className: "text-center" },
        { data: "d22", className: "text-center" },
        { data: "d23", className: "text-center" },
        { data: "d24", className: "text-center" },
        { data: "d25", className: "text-center" },
        { data: "d26", className: "text-center" },
        { data: "d27", className: "text-center" },
        { data: "d28", className: "text-center" },
        { data: "d29", className: "text-center" },
        { data: "d30", className: "text-center" },
        { data: "d31", className: "text-center" },
      ],
      columnDefs: [
        {
          targets: [7, 8, 9, 10] /* column index */,
          orderable: false /* true or false */,
        },
      ],
      drawCallback: function(settings) {
        self.reAaIsInitial = false;
        self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
      },
    })
    .on("error.dt", function ( e, settings, techNote, message ) {
      DatatableWarning.alert(techNote);
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/AdminReport/Survey.vue